// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"socialMedia-module--socialLinks--1An4S","socialLinks__li":"socialMedia-module--socialLinks__li--1t35_"};